export default class JSONParseError extends Error {
    constructor(jsonString) {
        super('Failed to parse firehose response');
        this.jsonString = jsonString;
        this.name = 'JSONParseError';
        this.jsonString = jsonString;
    }
}
//# sourceMappingURL=JSONParseError.js.map